import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "update-base-section" }
const _hoisted_2 = { class: "update-base-section__container" }
const _hoisted_3 = {
  key: 2,
  class: "item--checkbox"
}
const _hoisted_4 = ["for"]

import { i18n } from '@/i18n';
import { useUpdateBaseBusinessForm } from '@/corePagesModule/updateBusinessModal/composables/useUpdateBaseBusinessForm';
import AddOptionWideSection from './AddOptionWideSection.vue';
import { formOptionsBusiness, inputTypeKeyMap, keyMappingForSelectInput } from '@/corePagesModule/updateBusinessModal/constants';
import MultipleUserSelectInput from '@/corePagesModule/user/SelectInput/MultipleUserSelectInput.vue';
import SingleSelectInput from '@/corePagesModule/SelectInput/SingleSelectInput.vue';
import { ref } from 'vue';
import { UserAccount } from '@/coreDomainsModule/entities/users';
import { BaseBusinessNullableFormState, BASE_BUSINESS_NULLABLE_FORM_DEFAULT_STATE, BaseBusinessNullableFormItem } from '../constants';
import { UNASSIGNED_COLUMN } from '@/coreDomainsModule/constants';
import TableCheckbox from './TableCheckbox.vue';
import { BusinessFreeColumnValue, IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { SettingRepository } from '@/coreInfrastructureModule/Repositories/SettingRepository';
import TextInput from '@/unmanagedBusinessModule/components/TextInput.vue';
import MultiTagInput from '@/corePagesModule/components/MultiTagInput.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateBaseBusinessWideSection',
  setup(__props, { expose: __expose }) {

const t = i18n.t;

const {
  fieldState,
  allValidate,
  isEdited,
  addNewOption,
  updateValue,
  updateUserValue,
  createBaseBusinessPatch,
  currentOpenSelectInputName,
  initializeForm,
} = useUpdateBaseBusinessForm({
  validateRuleKeyMap: {
    customerNumber: [],
    customerName: [],
    salesDestinationNumber: [],
    salesDestinationName: [],
    endUser: [],
    baseBusinessResponsibleUser: [],
  },
});

const selectedUserAccounts = ref<UserAccount[]>([]);
const nullableFormState = ref<BaseBusinessNullableFormState>({ ...BASE_BUSINESS_NULLABLE_FORM_DEFAULT_STATE });
const businessFreeColumnValues = ref<BusinessFreeColumnValue[]>([]);
const editedBusinessFreeColumnNos = ref(new Set<number>());
const settingRepository = new SettingRepository();

/**
 * ユーザー情報をuserAccountsのまま変更する
 * @param userAccounts - 変更後ユーザー情報
 */
const updateUserAccountsValue = (userAccounts: UserAccount[]) => {
  selectedUserAccounts.value = userAccounts;
};

/**
 * NULLにするチェックボックスのハンドラ
 * @param option - ヘッダー名
 * @param isChecked - チェックの有無
 */
const isChangedNullableCheckbox = (option: string, isChecked: boolean) => {
  nullableFormState.value[option] = isChecked;
  updateValue(option, '');
};

/** 自由欄設定を取得して一括編集フォームに反映する */
const initializeBusinessFreeColumns = async () => {
  const result = await settingRepository.getBusinessFreeColumnSetting();
  if (result.status.type !== 'success') {
    businessFreeColumnValues.value = [];
    return;
  }
  businessFreeColumnValues.value = result.status.data.base
    .map((item, index) => ({
      columnNo: index + 1,
      headerName: item.headerName,
      isMulti: item.isMulti,
      isConfigured: item.isConfigured ?? false,
      value: '',
      target: 'base' as const,
    }))
    .filter((item) => item.isConfigured);
};

/**
 * 自由欄の入力値を更新する
 * @param index - 自由欄配列のindex
 * @param value - 入力値
 */
const updateBusinessFreeColumnValue = (index: number, value: string) => {
  const target = businessFreeColumnValues.value[index];
  if (!target) return;
  target.value = value;
  editedBusinessFreeColumnNos.value.add(target.columnNo);
  isEdited.value = true;
};

/** 変更された自由欄を含む関連取引一括編集patchを作成する */
const createBaseBusinessPatchWithFreeColumns = (): Partial<IBusiness> => ({
  ...createBaseBusinessPatch(),
  businessFreeColumnValues: businessFreeColumnValues.value
    .filter((item) => editedBusinessFreeColumnNos.value.has(item.columnNo))
    .map((item) => ({ ...item })),
});

/**
 * 自由入力カラムの編集状態を変更する
 */
const markBusinessFreeColumnEdited = () => {
  isEdited.value = true;
};

initializeBusinessFreeColumns();

__expose({
  fieldState,
  nullableFormState,
  selectedUserAccounts,
  businessFreeColumnValues,
  allValidate,
  isEdited,
  createBaseBusinessPatch: createBaseBusinessPatchWithFreeColumns,
  initializeForm,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formOptionsBusiness), (option, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: option,
          class: "item"
        }, [
          (_unref(inputTypeKeyMap)[option] === 'selectUser')
            ? (_openBlock(), _createBlock(MultipleUserSelectInput, {
                key: 0,
                "select-input-index": index,
                label: "",
                placeholder: nullableFormState.value[option] ? _unref(t)(_unref(UNASSIGNED_COLUMN)) : _unref(t)(option),
                "original-selected-user-id-list": _unref(fieldState)[option].value.value ? _unref(fieldState)[option].value.value.split(',') : [],
                disabled: nullableFormState.value[option],
                "onUpdate:modelValueUserAccounts": updateUserAccountsValue,
                "onUpdate:modelValue": (e) => _unref(updateUserValue)(option, e)
              }, null, 8, ["select-input-index", "placeholder", "original-selected-user-id-list", "disabled", "onUpdate:modelValue"]))
            : (_openBlock(), _createBlock(SingleSelectInput, {
                key: 1,
                index: index,
                label: "",
                "model-value": nullableFormState.value[option] ? _unref(t)(_unref(UNASSIGNED_COLUMN)) : _unref(fieldState)[option].value.value,
                placeholder: _unref(t)(option),
                "filter-type": _unref(keyMappingForSelectInput)[option],
                "is-error": _unref(fieldState)[option]?.isError.value,
                "error-message": _unref(fieldState)[option]?.errorMessage.value,
                disabled: nullableFormState.value[option],
                "disable-unassigned-column": "",
                "onClick:selectInput": () => (currentOpenSelectInputName.value = option),
                "onUpdate:modelValue": (e) => _unref(updateValue)(option, e)
              }, null, 8, ["index", "model-value", "placeholder", "filter-type", "is-error", "error-message", "disabled", "onClick:selectInput", "onUpdate:modelValue"])),
          ((_unref(BaseBusinessNullableFormItem) as readonly string[]).includes(option))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("label", {
                  for: `cb-${option}`
                }, _toDisplayString(_unref(t)('この項目を空白にする')), 9, _hoisted_4),
                _createVNode(TableCheckbox, {
                  "input-id": `cb-${option}`,
                  "is-checked": nullableFormState.value[option],
                  size: 14,
                  onChange: (isChecked) => isChangedNullableCheckbox(option, isChecked)
                }, null, 8, ["input-id", "is-checked", "onChange"])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessFreeColumnValues.value, (freeColumn, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: freeColumn.columnNo,
          class: "item"
        }, [
          (freeColumn.isMulti)
            ? (_openBlock(), _createBlock(MultiTagInput, {
                key: 0,
                "model-value": freeColumn.value,
                label: "",
                placeholder: freeColumn.headerName,
                onEditing: markBusinessFreeColumnEdited,
                "onUpdate:modelValue": (e) => updateBusinessFreeColumnValue(index, e)
              }, null, 8, ["model-value", "placeholder", "onUpdate:modelValue"]))
            : (_openBlock(), _createBlock(TextInput, {
                key: 1,
                "model-value": freeColumn.value,
                label: "",
                placeholder: freeColumn.headerName,
                "ensure-error-msg-height": "",
                "error-message-position": "bottom",
                "onUpdate:modelValue": (e) => updateBusinessFreeColumnValue(index, e)
              }, null, 8, ["model-value", "placeholder", "onUpdate:modelValue"]))
        ]))
      }), 128))
    ]),
    _createVNode(AddOptionWideSection, {
      "is-aggregate-business": false,
      onSetOption: _unref(addNewOption)
    }, null, 8, ["onSetOption"])
  ]))
}
}

})